import common from './common.js'
import store from '../store/store'
import http from './http.js'
import OSS from 'ali-oss'
import {
	Message
} from 'element-ui';
import i18n from '../src/lang' //语言包
/** 
 * oss类
 *  
 */
let client = common.client
export default {
	getUrlParams(url, name) {
		// 不传name返回所有值，否则返回对应值
		var search = url
		var pattern = new RegExp('[?&]' + name + '=([^&]+)', 'g')
		var matcher = pattern.exec(search)
		var items = null
		if (matcher != null) {
			try {
				items = decodeURIComponent(decodeURIComponent(matcher[1]))
			} catch (e) {
				try {
					items = decodeURIComponent(matcher[1])
				} catch (e) {
					items = matcher[1]
				}
			}
		}
		return items
	},
	$CheckIsNullOrEmpty(value) {
	  // 正则表达式用于判斷字符串是否全部由空格或换行符组成
	  let reg = /^\s*$/
	  // 有值 返回true
	  // 无值 返回false
	  return value !== null && value !== undefined && !reg.test(value)
	},
	// 获得评比类型
	getRatingType(type) {
		let result = "";
		if (type == 1) {
			result = "自学任务个数"
		} else if (type == 2) {
			result = "上课次数"
		} else if (type == 3) {
			result = "作业任务个数"
		} else if (type == 4) {
			result = "自学总分"
		} else if (type == 5) {
			result = "作业总分"
		} else if (type == 6) {
			result = "累计跟读学分"
		} else if (type == 7) {
			result = "累计跟读学分"
		} else if (type == 8) {
			result = "累计跟读+练习学分"
		} else if (type == 9) {
			result = "累计跟读+练习学分"
		}
		return result
	},
	ttlCx(path, callback) {
		let studentId = localStorage.getItem('userId')
		if (studentId) {
			http
				.get(`${common.baseUrl}/freeProject/freeProjectStudent/${studentId}`)
				.then((res) => {
					if (res.dataModel) {
						let gradeExpireTime = res.dataModel.endDate
						let path_ = path + '&gradeExpireTime=' + gradeExpireTime
						callback(path_)
					} else {
						callback(path)
					}
				})
		}
	},
	// 保存二维码信息
	saveQrcode(path, key = 'student-mb') {
		return new Promise((resolve, reject) => {
			let content = {
				systemKey: key,
				path: path
			}
			let url = `${common.baseUrl}/sale/qrCode`
			http
				.post(url, {
					content: JSON.stringify(content)
				})
				.then((res) => {
					if (res.success) {
						resolve(res)
					} else {
						this.webToast('warning', res.message)
					}
				})
		})
	},
	getCurrentAgent() {
	  let result = 'app'
	  let ua = navigator.userAgent.toLowerCase() // 获取判断用的对象
	  if (typeof window.WebViewJavascriptBridge === 'object') {
	    result = 'app'
	  } else {
	    if (
	      ua.match(/MicroMessenger/i) == 'micromessenger' &&
	      ua.match(/wxwork/i) == 'wxwork'
	    ) {
	      // alert("企业微信客户端");
	      result = 'businessWX'
	    } else if (ua.match(/micromessenger/i) == 'micromessenger') {
	      // alert("微信客户端");
	      result = 'weixin'
	      if (typeof wx === 'undefined') {
	        
	      } else {
	        wx.miniProgram.getEnv(function (res) {
	          if (res.miniprogram) {
	            // 小程序环境下逻辑
	            result = 'weixinxcx'
	          }
	        })
	      }
	      
	    }
	  }
	  return result
	},
	
	getIsDiscount(callback) {
		let stuId = localStorage.getItem('userId')
		if (stuId) {
			if (this.comparisonTime('isDiscount')) {
				let obj = JSON.parse(localStorage.getItem('isDiscount'))
				callback(obj)
			} else {
				http
					.get(`${common.baseUrl}/free/freeLearningCardBuying/${stuId}`)
					.then((res) => {
						if (res.success) {
							if (res.dataModel) {
								res.dataModel.guoqiData =
									new Date().getTime() + 60 * 60 * 1000 * 6
								localStorage.setItem(
									'isDiscount',
									JSON.stringify(res.dataModel)
								)
								callback(res.dataModel)
							} else {
								callback()
							}
						}
					})
			}
		}
	},
	getFreeTagAndCourse(callback) {
    let studentId = localStorage.getItem('userId')
    if (studentId) {
      if (this.comparisonTime('freeTagAndCourse')) {
        let obj = JSON.parse(localStorage.getItem('freeTagAndCourse'))
        callback(obj)
      } else {
        http.get(`${common.baseUrl}/freeProject/${studentId}/freeTagAndCourse`).then((res) => {
          if (res.success) {
            if (res.dataModel) {
              let nowTime = Date.parse(new Date())
              let TagAndCourse = res.dataModel
              TagAndCourse.nowTime = nowTime
              TagAndCourse.guoqiData = new Date().getTime() + 60 * 60 * 1000 * 1
              localStorage.setItem(
                'freeTagAndCourse',
                JSON.stringify(TagAndCourse)
              )
              callback(TagAndCourse)
            }
          }
        })
      }
    }
  },
	getFreeIsDiscount() {
		localStorage.removeItem('isDiscount')
		let stuId = localStorage.getItem('userId')
		if (stuId) {
			http
				.get(`${common.baseUrl}/free/freeLearningCardBuying/${stuId}`)
				.then((res) => {
					if (res.success) {
						if (res.dataModel) {
							res.dataModel.guoqiData = new Date().getTime() + 60 * 60 * 1000 * 6
							// localStorage.setItem('isDiscount', JSON.stringify(res.dataModel))
						}
					}
				})
		}
	},
	getAppletAddress(obj, callback) {
		http
			.get(`${common.baseUrl}/oralTraining/createGenerateLink`, obj)
			.then((res) => {
				let dataModel = res.dataModel

				callback(dataModel)
			})
	},
	getCompetitionAddress(obj, callback) {
		http
			.get(`${common.baseUrl}/newCompetition/createGenerateLink`, obj)
			.then((res) => {
				let dataModel = res.dataModel

				callback(dataModel)
			})
	},
	// 更新StorageData
	updateStorageData(key, value, time) {
		let oldVal = this.getStorageData(key, time)
		if (oldVal) {
			let obj = JSON.parse(localStorage.getItem(key))
			obj.value = value
			// 存入旧的时间，只更新值
			this.setStorageData(key, value, obj.time)
		} else {
			this.setStorageData(key, value, new Date().getTime())
		}
	},
	// 存入缓存 time当前时间
	setStorageData(key, value, time) {
		let obj = {
			time: time,
			value: value
		}
		localStorage.setItem(key, JSON.stringify(obj))
	},
	formatPublishTime(time) {
		time = new Date(time)
		let year = time.getFullYear()
		let month =
			time.getMonth() + 1 < 10 ?
			'0' + (time.getMonth() + 1) :
			time.getMonth() + 1
		let date = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
		let engMonth = ''
		if (month == '01') {
			engMonth = 'Jan'
		} else if (month == '02') {
			engMonth = 'Feb'
		} else if (month == '03') {
			engMonth = 'Mar'
		} else if (month == '04') {
			engMonth = 'Apr'
		} else if (month == '05') {
			engMonth = 'May'
		} else if (month == '06') {
			engMonth = 'Jun'
		} else if (month == '07') {
			engMonth = 'Jul'
		} else if (month == '08') {
			engMonth = 'Aug'
		} else if (month == '09') {
			engMonth = 'Sep'
		} else if (month == '10') {
			engMonth = 'Oct'
		} else if (month == '11') {
			engMonth = 'Nov'
		} else if (month == '12') {
			engMonth = 'Dec'
		}
		return `${date} ${engMonth} ${year}`
	},
	// 直接上传文件到阿里
	async putOssObject(ossFile, localFile) {
		client = new OSS({
			region: common.ossObject.region,
			accessKeyId: common.ossObject.accessKeyId,
			accessKeySecret: common.ossObject.accessKeySecret,
			bucket: common.ossObject.bucket
		})
		console.log('client', client)
		let result = client.multipartUpload(ossFile, localFile, {
			progress: async function(p, checkpoint) {
				let percent = Math.round(Number(p) * 100)
				if (percent >= 100) {
					setTimeout(() => {
						// store.dispatch("common/changeUploadFileDialogVisible", false)
					}, 2000)
				}
				// store.dispatch("common/changeUploadFilePercent", percent)
			}
		})
		return result
	},

	// 判断oss中文件是否存在
	async doesTheFileExist(data, ossKey, options={}) {
		client = new OSS({
				region: data.region,
				accessKeyId: data.accessKeyId,
				accessKeySecret: data.accessKeySecret,
				bucket: data.bucket
		}) 
		console.log(data);
		let exist
		try {
				await client.head(ossKey, options);
				exist = true
				console.log('文件存在')
		}  catch (error) {
				if (error.code === 'NoSuchKey') {
						console.log('文件不存在')
						exist = false
				}
		}
		return exist
	},

	// 下载
	async downloadOssMp3(key) {
		client = new OSS({
				region: common.ossObject.region,
				accessKeyId: common.ossObject.accessKeyId,
				accessKeySecret: common.ossObject.accessKeySecret,
				bucket: common.ossObject.bucket
		})
		// 配置响应头实现通过URL访问时自动下载文件，并设置下载后的文件名。
		const filename = key
		const response = {
		'content-disposition': `attachment; filename=${encodeURIComponent(key)}`
		}
		// 填写Object完整路径。Object完整路径中不能包含Bucket名称。
		const url = client.signatureUrl(key, { response });
		console.log(url);
		return url

},
	// 取出缓存 过期时间
	getStorageData(key, time) {
		try {
			var obj = JSON.parse(localStorage.getItem(key))
			if (obj) {
				let nowTime = new Date().getTime()
				if (nowTime * 1 - obj.time * 1 >= time * 1) {
					return ''
				} else {
					return obj.value
				}
			} else {
				return ''
			}
		} catch (e) {
			return ''
		}
	},
	// 设置监听器
	watch(ctx, obj) {
		Object.keys(obj).forEach((key) => {
			this.observer(ctx.data, key, ctx.data[key], function(value) {
				obj[key].call(ctx, value)
			})
		})
	},
	// 邀请好友成功后添加互为好友
	addFriend(initiatorOpenId, unionId) {
		if (initiatorOpenId && unionId && initiatorOpenId != unionId) {
			let friendUrl = `${common.baseUrl}/oralTraining/collecting/friendList/${initiatorOpenId}/${unionId}`
			http.put(friendUrl).then((res) => {})
		}
	},
	// 获取用户信息
	getUserInfoData(unionId, callback) {
		if (this.comparisonTime('userInfoData')) {
			let obj = JSON.parse(localStorage.getItem('userInfoData'))
			callback(obj)
		} else {
			let url = `${common.baseUrl}/oralTraining/userInfo/${unionId}`
			http.get(url).then((res) => {
				if (res.success) {
					let dataModel = res.dataModel || {}
					dataModel.guoqiData = new Date().getTime() + 60 * 60 * 1000 * 6
					localStorage.setItem('userInfoData', JSON.stringify(dataModel))
					setTimeout(() => {
						common.initSign && common.initSign()
					}, 1000)
					callback(dataModel)
				}
			})
		}
	},
	getlanguage(this_, navigator) {
		let userInfo =
			(localStorage.getItem('userInfo') &&
				JSON.parse(localStorage.getItem('userInfo'))) || {}
		//  设置初始语言
		let langMode = userInfo.lang
		let langKey = 'en'
		if (userInfo.lang) {
			if (langMode == 'zh-TW') {
				langKey = 'tw'
			} else if (langMode == 'zh-CN') {
				langKey = 'zh'
			}
		} else {
			if (navigator == 'zh-tw') {
				langKey = 'tw'
			} else if (navigator == 'zh-cn') {
				langKey = 'zh'
			}
		}
		this_.$i18n.locale = langKey
		this_.$store.dispatch('common/changeLang', langKey)
		document.title = this_.$t('common.documentTitle')
	},

	// 多位数字每隔三位加一个逗号
	add_comma_toThousands(num) {
		var result = '';
		if (!(num || num == 0)) {
			return result
		}
		num = (num || 0).toString();
		while (num.length > 3) {
			result = ',' + num.slice(-3) + result;
			num = num.slice(0, num.length - 3);
		}
		if (num) {
			result = num + result;
		}
		return result;
	},
	/** 
	 * @description 通过 ossKey 得到完整的链接
	 * @param {String} ossKey 
	 * @returns {String}
	 */
	// getOssFileUrl(ossKey,type) {
	// 	if (!ossKey) {
	// 		console.log('无效的文件')
	// 		return
	// 	}
	// 	let url = common.baseUrl + "/common/ossFileUrl?key=" + ossKey
	// 	if(type){
	// 		let newkey = ossKey.split('.')[0]+'thumb.webp';
	// 		url = common.baseUrl + '/common/ossFileUrl?key=' + newkey
	// 	}
	// 	return url
	// },
	getOssFileUrlA(ossKey) {
		if (!ossKey) {
				console.log('无效的参数')
				return
		}
		if (ossKey.includes('http')) {
		  return ossKey
		} else if (
		  common.domain.indexOf('t.witsbox.com') > -1 ||
		  common.domain.indexOf('t2.witsbox.com') > -1 ||
		  common.domain.indexOf('t.dailyedu.com') > -1
		) {
		  return (
		    'https://witsbox-school-test.oss-cn-shanghai.aliyuncs.com/' + ossKey
		  )
		} else {
		  return 'https://witsbox-school.oss-accelerate.aliyuncs.com/' + ossKey
		}
	},
	getOssFileUrl(ossKey) {
		if (!ossKey) {
				console.log('无效的参数')
				return
		}
		let url = ''
		if(ossKey.includes('http')){
			  url = ossKey
		}else if (window.location.host.indexOf('eu.ttx.la') > -1) {
				url = `${common.baseUrl}/common/ossFileUrl?key=${ossKey}&urlType=eu`
		} else if (window.location.host.indexOf('hk.ttx.la') > -1) {
				url = `${common.baseUrl}/common/ossFileUrl?key=${ossKey}&urlType=hk`
		} else {
				url = common.baseUrl + '/common/ossFileUrl?key=' + ossKey+'&urlType=oss'
		}
		return url
	},
	oralTGetOssFileSignatureUrl(data, ossKey) {
    client = new OSS({
      region: data.region,
      accessKeyId: data.accessKeyId,
      accessKeySecret: data.accessKeySecret,
      bucket: data.bucket
    })
    if (!ossKey) {
      console.log('无效的参数')
      return
    }
    let url = client.signatureUrl(ossKey, {
      expires: 3600
    })
    return url
  },
	
	/* 生成随机位数的uid,此处用于存入阿里的uid */
	getUUid() {
		let str = new Date().getTime(),
			pos = '',
			arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e',
				'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u',
				'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K',
				'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
			];
		for (var i = 0; i < 11; i++) {
			pos = Math.round(Math.random() * (arr.length - 1));
			str += arr[pos];
		}
		return str;
	},
	getParamsStr(list, type) {
		let str = ''
		if (list && list.length) {
			list.forEach((i) => {
				if (i.name) {
					str = str + `${i.name}${i.value ? `:${i.value}` : ''}`
				}
			})
			return str
		} else {
			return ''
		}
	},
	isToday(time) {
		let day2 = new Date()
		let today = this.formatDate(new Date(), 'yyyy.mm.dd')
		let timeTody = this.formatDate(time, 'yyyy.mm.dd')
		if (today == timeTody) {
			return '今日'
		} else {
			return '明日'
		}
	},
	comparisonTime(name) {
		if (!localStorage.getItem(name)) {
			return false
		}
		let name_ = JSON.parse(localStorage.getItem(name))
		let s2
		if (typeof name_ === 'object') {
			s2 = name_.guoqiData
		} else {
			s2 = name_
		}
		let s1 = new Date().getTime()
	
		if (s1 < s2) {
			return true
		} else {
			localStorage.removeItem(name)
			return false
		}
	},
	unique(arr) {
		var newArr = []
		for (var i = 0; i < arr.length; i++) {
			if (newArr.indexOf(arr[i]) == -1) {
				newArr.push(arr[i])
			}
		}
		return newArr
	},
	getRemainderTime(startTime, time, name) {
		if (!localStorage.getItem(name)) {
			return false
		}
		var s1 = startTime
		var s2 = new Date().getTime()
		var runTime = parseInt((s2 - s1) / 1000)
		var year = Math.floor(runTime / 86400 / 365)
		runTime = runTime % (86400 * 365)
		var month = Math.floor(runTime / 86400 / 30)
		runTime = runTime % (86400 * 30)
		var day = Math.floor(runTime / 86400)
		runTime = runTime % 86400
		var hour = Math.floor(runTime / 3600)
		runTime = runTime % 3600
		// var minute = Math.floor(runTime / 60)
		runTime = runTime % 60
		// var second = runTime
		let flag = false
		if (time == 15) {
			if (year == 0 && month == 0 && day == 0 && hour == 0 && time < 15) {
				flag = true
			} else {
				localStorage.removeItem(name)
			}
		}
		if (time == 60) {
			if (year == 0 && month == 0 && day == 0 && hour < 1 && time < 60) {
				flag = true
			} else {
				localStorage.removeItem(name)
			}
		}
		return flag
	},
	removeSpecifiedHistory(arr) {
		let historyArr =
			(localStorage.getItem('StudentmbHistoryArr') &&
				JSON.parse(localStorage.getItem('StudentmbHistoryArr'))) || []
		for (var i = 0; i < historyArr.length; i++) {
			for (var m = 0; m < arr.length; m++) {
				if (historyArr[i].key == arr[m]) {
					historyArr.splice(i, 1)
				}
			}
		}
	
		localStorage.setItem('StudentmbHistoryArr', JSON.stringify(historyArr))
	},
	removeHistory() {
		let historyArr =
			(localStorage.getItem('StudentmbHistoryArr') &&
				JSON.parse(localStorage.getItem('StudentmbHistoryArr'))) || []
		historyArr.pop()
		localStorage.setItem('StudentmbHistoryArr', JSON.stringify(historyArr))
	},
	/**
	 * 根据角色显示
	 * @param {Array} inputRoles 显示的角色id数组
	 * @returns {Boolean} true 显示 false 隐藏
	 */
	showByRoles(inputRoles) {
		let roles = JSON.parse(localStorage.getItem('role'))
		if (inputRoles.length) {
			// 是否有权限
			let flag = false
			for (let i = 0; i < inputRoles.length; i++) {
				if (roles.indexOf(inputRoles[i]) > -1) {
					flag = true
					break
				}
			}
			return flag
		}
	},
	/**
	 * 从对象里取出特定属性放入新对象
	 * @param {Object} obj 
	 * @param {Array} arr 属性数组
	 * @returns {Object} 新的对象
	 */

	pick: (obj, arr) =>
		arr.reduce((iter, val) => (val in obj && (iter[val] = obj[val]), iter), {}),

	/**xxxx-xx-xx to xxxxxxxx or to xxxx/xx/xx
	 * 日期之间符号
	 * @param {String} character 字符
	 * @param {String} date 日期
	 * @return 格式化之后的日期
	 */
	transferNormalDate(date, character) {
		if (date && date.indexOf('-') > 0) {
			return date.split('-').join(character)
		} else {
			throw new Error('日期格式不正确，应为yyyy-mm-dd')
		}
	},

	/** 去空格
	 * @str 字符串
	 */
	delHtmlTag(str) {
		var str = str.replace(/<\/?[^>]*>/gim, ""); //去掉所有的html标记
		var result = str.replace(/(^\s+)|(\s+$)/g, ""); //去掉前后空格
		return result.replace(/\s/g, ""); //去除文章中间空格
	},
	// 2018-11-14 03:33:07 时间转换为时间戳（13位）
	formatTime(time) {
		let _time = time;
		_time = _time.replace(/-/g, '/');
		let result = new Date(_time);
		result = result.getTime();
		return result
	},

	/** 分辨率js判断
	 * @param {int} windowWidth 需要判断的宽度
	 */
	isRatio(windowWidth) {
		return window.innerWidth === windowWidth
	},

	/** 
	 * 时间戳格式化函数 
	 * @param  {int}    timestamp 要格式化的时间 
	 * @param  {string}           时间格式(yyyy-mm-dd, hh:mm 或者 yyyy-mm-dd hh:mm, yyyy.mm.dd, yyyy/mm/dd hh:mm, yyyy/mm/dd)
	 * @return {string}           格式化的时间字符串 
	 */
	formatTimeStamp(time, format) {
		time = new Date(time);
		var year = time.getFullYear();
		var month = time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : (time.getMonth() + 1);
		var date = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
		var hour = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
		var minute = time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
		// var second = time.getSeconds();
		if (format == "yyyy-mm-dd") {
			return year + "-" + month + "-" + date;
		} else if (format == "hh:mm") {
			return hour + ":" + minute;
		} else if (format == 'yyyy.mm.dd') {
			return year + "." + month + "." + date;
		} else if (format == 'yyyy/mm/dd') {
			return year + "/" + month + "/" + date;
		} else if (format == 'yyyy/mm/dd hh:mm') {
			return year + "/" + month + "/" + date + " " + hour + ":" + minute;
		} else {
			return year + "-" + month + "-" + date + " " + hour + ":" + minute;
		}
	},
	/**类型判断
	 *  @param {Object} val 判断的值
	 *  @param {String} type 想要判断的类型
	 *  @returns {Boolean}
	 */
	isType(val, type) {
		return Object.prototype.toString.call(val) === `[object ${type}]`
	},

	// 跳转新页面
	openNewWindow(url) {
		// 之后可能区分本地 测试 开发
		window.open(common.hostUrl + url)
	},
	/**
	 * null转化为''
	 */
	nullToQuote(obj) {
		let objIsArr = this.isType(obj, 'Array')
		// 是数组 递归里面的 里面的是对象或者数组 递归 不是 就改值
		if (objIsArr) {
			obj.forEach(i => this.isType(i, 'Object') || this.isType(i, 'Array') ? this.nullToQuote(i) : i == null ?
				'' : i)
		} else {
			// 对象里的属性 是数组或者对象 就继续递归
			for (let key in obj) {
				if (this.isType(obj[key], 'Object') || this.isType(obj[key], 'Array')) {
					this.nullToQuote(obj[key])
				} else {
					obj[key] = obj[key] == null ? "" : obj[key];
				}
			}
		}
		return obj;
	},
	// 根据idx生成序号 用于列表生成3位序号
	/**
	 * @num 传入的序号
	 */
	generateNumByLgth(num) {
		let numStr = `${num}`;
		let lgth = 3 - numStr.length;
		let idx = 0;
		while (idx < lgth) {
			numStr = "0" + numStr;
			idx++;
		}
		return numStr;
	},
	// 给列表数据 加序号
	/**
	 * @propertyName 列表约定的属性名
	 * @pageNo 页码
	 * @pageSize 页数
	 * @list 列表数据
	 */
	generateNumForList(propertyName, pageNo, pageSize, list) {

		if (!list.length || !Boolean(list)) {
			return []
		}

		list && list.forEach((i, idx) => {
			//  i.code
			if (i) {
				i = this.nullToQuote(i)
				i[propertyName] = this.generateNumByLgth(
					(pageNo - 1) * pageSize + idx + 1
				);
			}
		});
		return list || []
	},
	// 获取userInfo里的对应key
	_getAttrOfUserInfo: key => {
		const userInfo = JSON.parse(localStorage.getItem('userInfo'));
		return !!userInfo && userInfo.hasOwnProperty(key) ? userInfo[key] : 0
	},
	// 数组去重
	removeDuplicateItems: arr => [...new Set(arr)],
	// 函数节流 当持续触发事件时，保证一定时间段内只调用一次事件处理函数。
	throttle: function(func, delay) {
		var prev = Date.now();
		return function() {
			var context = this;
			var args = arguments;
			var now = Date.now();
			if (now - prev >= delay) {
				func.apply(context, args);
				prev = Date.now();
			}
		}
	},
	getQueryString(url = "", name) {
		var search = url ? url : window.location.href;
		var pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g");
		var matcher = pattern.exec(search);
		var items = null;
		if (null != matcher) {
			try {
				items = decodeURIComponent(decodeURIComponent(matcher[1]));
			} catch (e) {
				try {
					items = decodeURIComponent(matcher[1]);
				} catch (e) {
					items = matcher[1];
				}
			}
		}
		return items;
	},

	getNowFormatDate() {
		var date = new Date();
		var seperator1 = '-';
		var seperator2 = ':';
		var month = date.getMonth() + 1;
		var strDate = date.getDate();
		if (month >= 1 && month <= 9) {
			month = '0' + month;
		}
		if (strDate >= 0 && strDate <= 9) {
			strDate = '0' + strDate;
		}
		var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate +
			' ' + date.getHours() + seperator2 + date.getMinutes();
		return currentdate;
	},
	/** 时间戳转为日期
	 * @date {int} timestamp
	 * @format {String} 日期格式
	 */
	formatDate(date, format = "yyyy.mm.dd H:i:s", isCompletion = true) {
		if (!date) {
			return "";
		}

		if (typeof date == "string") {
			date = date.replace(/\-/g, "/");
		}
		// console.log(typeof(date));

		//			console.log(typeof(date));
		date = new Date(date);
		// 将接口返的时间格式转为 y-m-d H:i:s
		var y = date.getFullYear();
		var m = date.getMonth() + 1;
		if (isCompletion) m = m < 10 ? "0" + m : m;
		var d = date.getDate();
		if (isCompletion) d = d < 10 ? "0" + d : d;
		var h = date.getHours();
		h = h < 10 ? "0" + h : h;
		var minute = date.getMinutes();
		minute = minute < 10 ? "0" + minute : minute;
		var second = date.getSeconds();
		second = second < 10 ? "0" + second : second;
		var result;
		switch (format) {

			case "H:i:s":
				result = h + ":" + minute + ":" + second;
				break;
			case "yyyy-mm":
				result = y + "-" + m;
				break;
			case "yyyy-mm-dd":
				result = y + "-" + m + "-" + d;
				break;
			case "yyyy-mm-dd H:i":
				result = y + "-" + m + "-" + d + " " + h + ":" + minute;
				break;
			case "yyyy/mm/dd":
				result = y + "/" + m + "/" + d;
				break;
			case "yyyy/mm":
				result = y + "/" + m;
				break;
			case "yyyy年mm月dd日":
				result = y + "年" + m + "月" + d + "日";
				break;
			case "yyyy年mm月dd日 H:i:s":
				result =
					y +
					"年" +
					m +
					"月" +
					d +
					"日" +
					" " +
					h +
					":" +
					minute +
					":" +
					second;
				break;
			case "mm月dd日 H:i":
				result =
					m +
					"月" +
					d +
					"日" +
					" " +
					h +
					":" +
					minute;
				break;
			case "yyyy/mm/dd H:i:s":
				result = y + "/" + m + "/" + d + " " + h + ":" + minute + ":" + second;
				break;
			case "yyyy/mm/dd H:i":
				result = y + "/" + m + "/" + d + " " + h + ":" + minute;
				break;
			case "yyyy.mm.dd":
				result = y + "." + m + "." + d;
				break;

			case "yyyy.mm.dd H:i":
				result = y + "." + m + "." + d + " " + h + ":" + minute;
				break;
			case "yyyy.mm.dd":
				result = y + "." + m + "." + d;
				break;
			case "mm.dd H:i":
				result = m + "." + d + " " + h + ":" + minute;
				break;
			case "mm.dd":
				result = m + "." + d;
				break;
			case "H:i":
				result = h + ":" + minute;
				break;
			case "H":
				result = h;
				break;
			default:
				result = y + "." + m + "." + d + " " + h + ":" + minute + ":" + second;
				break;
		}
		return result;
	},
	// 时间戳转换为 2018.11.12  周三 18:00-18:25 || 2018.11.12  周三 18:00
	// 今天 10:00-10:15 || 明天 10:00-10:15 || 2018.12.10  10:00-10:15 跨天只显示开始时间 
	getFormatTime(start, end, isNewFormat = false, canCrossDay = false, isShowWeek = false, isShowTime = true) {
		if (!start) return "";
		let startTime = {
			year: new Date(Number(start)).getFullYear(),
			month: this.fixedData(new Date(Number(start)).getMonth() + 1),
			day: this.fixedData(new Date(Number(start)).getDate()),
			hour: this.fixedData(new Date(Number(start)).getHours()),
			minute: this.fixedData(new Date(Number(start)).getMinutes())
		};
		let endTime = "";
		let week = this.getWeek(new Date(Number(start)));
		let result = this.showDay(isNewFormat, start, startTime);
		if (!result) {
			result += startTime.year + "." + startTime.month + "." + startTime.day;
		}
		result += (isShowWeek ? " " + week : "");
		result += (isShowTime ? (" " + startTime.hour + ":" + startTime.minute) : "");
		if (end) {
			endTime = {
				year: new Date(Number(end)).getFullYear(),
				month: this.fixedData(new Date(Number(end)).getMonth() + 1),
				day: this.fixedData(new Date(Number(end)).getDate()),
				hour: this.fixedData(new Date(Number(end)).getHours()),
				minute: this.fixedData(new Date(Number(end)).getMinutes())
			};
			result += this.isSameDay(startTime, endTime) ? //时间在同一天 则不显示结束的日期只显示时间
				(isShowTime ? ("-" + endTime.hour + ":" + endTime.minute) : "") :
				canCrossDay ? //允许跨天则只显示开始时间 不管结束
				"" : ("-" + endTime.year + "." + endTime.month + "." + endTime.day +
					(isShowTime ? //不显示时分
						" " + endTime.hour + ":" + endTime.minute :
						""));
		}
		return result;
	},


	// 主要用于小班课的显示
	// 今天 10:00-10:15 || 明天 10:00-10:15 || 6月11日14:00-14:30
	getNewFormatTime(start, end, isShowWeek = false, isShowTime = true) {
		if (!start || !end) return "";
		let startTime = {
			year: new Date(Number(start)).getFullYear(),
			month: new Date(Number(start)).getMonth() + 1,
			day: new Date(Number(start)).getDate(),
			hour: this.fixedData(new Date(Number(start)).getHours()),
			minute: this.fixedData(new Date(Number(start)).getMinutes())
		};
		let week = this.getWeek(new Date(Number(start)));
		let endTime = {
			year: new Date(Number(end)).getFullYear(),
			month: new Date(Number(end)).getMonth() + 1,
			day: new Date(Number(end)).getDate(),
			hour: this.fixedData(new Date(Number(end)).getHours()),
			minute: this.fixedData(new Date(Number(end)).getMinutes())
		};
		let result = this.showDay(start, 1);
		if (!result) {
			result += this.getUnitTime(startTime, 0);
		}
		result += isShowWeek ? " " + week : "";
		result += isShowTime ? (" " + startTime.hour + ":" + startTime.minute) : "";
		result += isShowTime ? ("-" + endTime.hour + ":" + endTime.minute) : "";
		return result;
	},
	// 6月3日 || 06.03
	getUnitTime(time, showYear) {
		let yearStr = showYear ? time.year + i18n.t("study.yearUnit") : "";
		if (this.isEn()) {
			return yearStr + this.fixedData(time.month) + "." + this.fixedData(time.day);
		} else {
			return yearStr + time.month + "月" + time.day + "日";
		}
	},
	// 是否是同一天
	isSameDay(startTime, endTime) {
		return startTime.year == endTime.year && startTime.month == endTime.month && startTime.day == endTime.day;
	},
	// 今天 明天
	showDay(start, isNewFormat) {
		let res = ""
		if (isNewFormat) {
			let nowDay = new Date(),
				nowT = new Date(nowDay.getFullYear(), nowDay.getMonth(), nowDay.getDate()),
				startDay = new Date(start),
				startT = new Date(startDay.getFullYear(), startDay.getMonth(), startDay.getDate()),
				dayT = parseInt((startT - nowT) / 1000 / 60 / 60 / 24);
			if (dayT == 0) {
				return i18n.t("study.today");
			} else if (dayT == 1) {
				return i18n.t("study.tomorrow");
			}
		}
		return res
	},
	//根据时间判断星期几
	getWeek(timedat) { // timedat参数格式：   getWeek（new Date("2017-10-27" )）
		let week;
		if (timedat.getDay() == 0) week = i18n.t("study.weekdate7");
		if (timedat.getDay() == 1) week = i18n.t("study.weekdate1");
		if (timedat.getDay() == 2) week = i18n.t("study.weekdate2");
		if (timedat.getDay() == 3) week = i18n.t("study.weekdate3");
		if (timedat.getDay() == 4) week = i18n.t("study.weekdate4");
		if (timedat.getDay() == 5) week = i18n.t("study.weekdate5");
		if (timedat.getDay() == 6) week = i18n.t("study.weekdate6");
		return week;
	},
	getShortWeek(str) {
		let week = str;
		if (str == 'Monday') week = 'Mon.';
		if (str == 'Tuesday') week = 'Tues.';
		if (str == 'Wednesday') week = 'Wed.';
		if (str == 'Thursday') week = 'Thur.';
		if (str == 'Friday') week = 'Fri.';
		if (str == 'Saturday') week = 'Sat.';
		if (str == 'Sunday') week = 'Sun.';
		return week;
	},
	getShortMonth(month) {
		let str = "";
		if (month == 1) str = 'Jan ';
		if (month == 2) str = 'Feb ';
		if (month == 3) str = 'Mar ';
		if (month == 4) str = 'Apr ';
		if (month == 5) str = 'May ';
		if (month == 6) str = 'Jun ';
		if (month == 7) str = 'Jul ';
		if (month == 8) str = 'Aug ';
		if (month == 9) str = 'Sept ';
		if (month == 10) str = 'Oct ';
		if (month == 11) str = 'Nov ';
		if (month == 12) str = 'Dec ';
		return str;
	},
	// Jun.25.2020
	getEnDate(time) {
		let m = this.getShortMonth(new Date(time).getMonth() + 1);
		let day = new Date(time).getDate();
		let year = new Date(time).getFullYear();
		return m + day + "," + year;
	},
	getMonthAndDay(date, showYear) {
		let result
		let year = new Date(Number(date)).getFullYear()
		let month = this.fixedData(new Date(Number(date)).getMonth() + 1)
		let day = this.fixedData(new Date(Number(date)).getDate())
		if (showYear) {
			result = year + "-" + month + "-" + day
		} else {
			result = month + "-" + day
		}
		return result
	},
	fixedData(time) {
		let data = Number(time)
		if (data < 10) {
			data = "0" + data
		}
		return data
	},
	//两个字->中间加空格，大于两个字，保持原样
	setBtnMsgByLength(msg) {
		//debugger  
		let result = "";
		if (msg && Object.prototype.toString.call(msg) === "[object String]") {
			result = msg.length == 2 ? msg.substring(0, 1) + " " + msg.substring(1, 2) : msg;
		}
		return result;
	},
	goBack() {
		window.history.go(-1)
	},
	// 选择多个教案，试卷，课件的排序
	sortMultiTableData(selectIds, selectObj, type) {
		// let selectIds = [1,2,4]
		// let selectObj = [{lessonId: 3, name: '授课3'}, {lessonId: 1, name: '授课1'}, {lessonId: 4, name: '授课4'}]
		let result = []
		selectIds.forEach((item) => {
			result.push({})
		})
		selectObj.forEach((item, index) => {
			let index1
			if (type == 'lesson') {
				index1 = selectIds.indexOf(item.lessonId)
			} else if (type == 'paper') {
				index1 = selectIds.indexOf(item.examPaperId)
			} else if (type == 'courseware') {
				index1 = selectIds.indexOf(item.coursewareId)
			} else if (type == 'teacher') {
				index1 = selectIds.indexOf(item.employeeId)
			} else if (type == 'project') {
				index1 = selectIds.indexOf(item.projectId)
			}

			if (index1 > -1) {
				result[index1] = item
			}
		})
		// result.forEach((item, index)=>{
		//   if(JSON.stringify(item) == "{}") {
		//     result.splice(index, 1)
		//   }
		// })
		let newResult = []
		result.forEach((item, index) => {
			// if(pageNo && pageSize) {
			//   if (index < pageNo * pageSize && index >= (pageNo - 1) * pageSize) {
			//     newResult.push(item)
			//     item.num = index + 1
			//   }
			// } else {
			newResult.push(item)
			item.num = index + 1
			// }
		})
		return newResult

	},
	//  判断当前是否是英文版
	isEn() {
		let local = localStorage.getItem('lang');
		return local == 'en';
	},
	// 把当前客户端时间转成背景时间
	getBeijingtime(date) {
		//获得当前运行环境时间
		let beijingTime;
		let currentDate = new Date(date);
		let tmpHours = currentDate.getHours();
		//算得时区
		var time_zone = -currentDate.getTimezoneOffset() / 60;
		if (time_zone < 0) {
			time_zone = Math.abs(time_zone) + 8;
			currentDate.setHours(tmpHours + time_zone);
		} else {
			time_zone -= 8;
			currentDate.setHours(tmpHours - time_zone);
		}
		beijingTime = this.formatDate(currentDate, "yyyy-mm-dd")
		let result = new Date(beijingTime + " 00:00").getTime()
		return result;
	},
	webToast(msg) {
		Message({
			customClass: "webStu-message",
			message: msg,
			center: true
		});
	},
	// 跳转下载 Dyned客户端
	openDynedApp() {
		store.dispatch("common/changeDynedJumpVisible", true)
		// Message({
		//   customClass: "webStu-message",
		//   message: "跳转下载客户端页面",
		//   center: true
		// });

	},
	getGMTTime() {
		let date = new Date().toString();
		let index = date.indexOf("GMT");
		let str = date.substring(index);
		return str
	},
	lessonLevelToString(level) {
		switch (level) {
			case 0, '零基础':
				return i18n.t("study.lessonLevel0");
				break;
			case 1, '初级':
				return i18n.t("study.lessonLevel1");
				break;
			case 2, '中级':
				return i18n.t("study.lessonLevel2");
				break;
			case 3, '高级':
				return i18n.t("study.lessonLevel3");
				break;
			case 4, '不限':
				return i18n.t("study.lessonLevel4");
				break;
			default:
				return level || "--";
		}
	},
	exitLogin() {
		sessionStorage.removeItem('LeveltestshowRX');
		localStorage.removeItem('commonToken');
		if (localStorage.getItem('loginHref')) {
			window.location.href = JSON.parse(localStorage.getItem('loginHref'))
		} else {
			window.location.href = common.loginPage
		}
	},
	winopen(href) {
		var a = document.createElement('a');
		a.setAttribute('href', href);
		a.setAttribute('target', '_blank');
		a.click();

		// let winHref = window.open("url", "_blank");
		// winHref.location.href = href;
	},
	// 生成token
  createCommonToken() {
    var str = ''
    let range = 20
    let arr = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z'
    ]
    for (var i = 0; i < range; i++) {
      let pos = Math.round(Math.random() * (arr.length - 1))
      str += arr[pos]
    }
    // let timestamp = (Date.parse(new Date()) + 86400000 * 61) * 7
    let timestamp = (Date.parse(new Date()) + 600000) * 7 // 10分钟
    let randomWord = str
    let token = randomWord + timestamp
    localStorage.setItem('commonToken', token)
  }
}



// WEBPACK FOOTER //
// ./utils/global.js